/* Shipping policy - TOC active state */
(function () {
  const links = [...document.querySelectorAll(".ship-toc a[href^='#']")];
  if (!links.length) return;

  const sections = links
    .map((a) => document.querySelector(a.getAttribute("href")))
    .filter(Boolean);

  function setActive(id) {
    links.forEach((a) => {
      a.classList.toggle("is-active", a.getAttribute("href") === `#${id}`);
    });
  }

  if ("IntersectionObserver" in window && sections.length) {
    const io = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible && visible.target.id) setActive(visible.target.id);
      },
      { rootMargin: "-20% 0px -55% 0px", threshold: [0.1, 0.35, 0.6] }
    );
    sections.forEach((s) => io.observe(s));
  }

  links.forEach((a) => {
    a.addEventListener("click", () => {
      const id = (a.getAttribute("href") || "").slice(1);
      if (id) setActive(id);
    });
  });
})();
